import type { ReactNode } from 'react'
import { Table } from 'antd'
import type { ColumnType, ColumnsType } from 'antd/es/table'

export interface SummaryLine {
  key: string
  /** Ustun kaliti → katak mazmuni; ko'rsatilmagan ustun bo'sh qoladi */
  cells: Readonly<Record<string, ReactNode>>
}

/**
 * Jami qatorlari ustun KALITI bo'yicha: ustunlar surilsa yoki yashirilsa ham son o'z ustuni
 * ostida qoladi. `leadingCells` — antd'ning tanlash/ochish ustunlari.
 */
export function renderSummary<T>(
  columns: ColumnsType<T>,
  lines: readonly SummaryLine[],
  leadingCells = 0,
): ReactNode {
  if (lines.length === 0) return null
  return (
    <>
      {lines.map((line) => (
        <Table.Summary.Row key={line.key}>
          {Array.from({ length: leadingCells }, (_, index) => (
            <Table.Summary.Cell key={`lead-${index}`} index={index} />
          ))}
          {columns.map((column, index) => {
            const { key, align } = column as ColumnType<T>
            const columnKey = String(key ?? index)
            return (
              <Table.Summary.Cell key={columnKey} index={leadingCells + index} {...(align ? { align } : {})}>
                {line.cells[columnKey]}
              </Table.Summary.Cell>
            )
          })}
        </Table.Summary.Row>
      ))}
    </>
  )
}
